export enum MenuActionType {
    GoToPreviousMenu,
}
